
class LanguageManagerSystem {
  framework;
  spanishMap;
  englishMap;

  constructor(_framework) {
    this.framework = _framework;
    this.spanishMap = new Map();
    this.englishMap = new Map();    
    this.initialize();
  }

  getSelectedLanguageCode() {
    let selectedLanguageCode = localStorage.getItem('selected_language');
    if(selectedLanguageCode !== null) {
      return selectedLanguageCode;
    }
    else {
      localStorage.setItem("selected_language","SPANISH");   
      return "SPANISH";
    }
  }

  setSelectedLanguageCode(_languageCode) {
    localStorage.setItem("selected_language",_languageCode);   
  }    

  getText(_textCode) {
    let selectedLanguage = this.getSelectedLanguageCode();
    let value = null;
    if("SPA" === selectedLanguage) {
      value = this.spanishMap.get(_textCode);      
    }
    else if("ENG" === selectedLanguage) {
      value = this.englishMap.get(_textCode);
    }
    else {
      value = this.spanishMap.get(_textCode);      
    } 
    return (value !== null)?value:"##" + _textCode +"##";
  }

  initialize() {
    this.addText("#GUEST#", "Visitante","Guest");
    this.addText("#GUESTS#", "Visitantes","Guests");
    this.addText("#RESERVATION#", "Reservación","Reservation");
  }


  addText(_textCode,_textInSpanish,_textInEnglish) {
    this.spanishMap.set(_textCode, _textInSpanish);
    this.englishMap.set(_textCode, _textInEnglish);
  }

}


export default LanguageManagerSystem;